/**
 * Copyright (c) Cisco Systems, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const appliedMixins = new WeakMap();
export const wasApplied = (mixin, superClass) => {
    const entries = appliedMixins.get(mixin);
    let proto = superClass;
    const chain = [];
    while (proto) {
        chain.push(proto);
        proto = Object.getPrototypeOf(proto);
    }
    return entries ? chain.reduce((res, protoClass) => res || entries.has(protoClass), false) : false;
};
export const DedupeMixin = (mixin, superClass) => {
    let entries = appliedMixins.get(mixin);
    if (!entries) {
        entries = new WeakSet();
        appliedMixins.set(mixin, entries);
    }
    entries.add(superClass);
};
